// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedHrp {
  color: black;
  transform: scale(1.05);
  margin: 1% 5%;
  cursor: pointer;
  font-weight: 500;
  
}

.notSelectedHrp {
  margin: 1% 5%;
  color: grey;
  cursor: pointer;
  
}

.notSelectedChecklist {
  height:27%;
  display:flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 2%;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-weight: 500;
  font-family: "Merriweather Sans";
  border-radius: 20px 20px 20px 20px ;
  width:95%;
  background-color: #fff;
}

.selectedChecklist {
  height:27%;
  display:flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 2%;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-size: 500;
  font-family: "Merriweather Sans";
  background-color: #A25035;
  color:white;
  transform: scale(1.02);
  border-radius: 20px 20px 20px 20px ;
  width:95%;
}

.notSelectedChecklistUser {
  font-size: 13px;
  font-weight: 500;
  margin-top: 3%;
  color: grey;
}

.selectedChecklistUser {
  font-size: 13px;
  font-weight: 500;
  margin-top: 3%;
  color: #fff;
}

.selectedChecklistIcon {
  float: right;
  font-size: 20px;
  margin: 5px;
  color: #fff;
  cursor: pointer;
}

.notSelectedChecklistIcon {
  float: right;
  font-size: 20px;
  margin: 5px;
  color: black;
  cursor: pointer;
}

.notSelectedHrpIcon {
  float:right;
  margin:2%;
  font-size: 20px;
}
.selectedHrpIcon {
  float:right;
  margin:2%;
  color:white;
  font-size: 20px;
}

.selectedHrpUser{
  color:white
}
`, "",{"version":3,"sources":["webpack://./src/components/modules/hrp/HrpNav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;;AAEjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,4EAA4E;EAC5E,gBAAgB;EAChB,gCAAgC;EAChC,mCAAmC;EACnC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,4EAA4E;EAC5E,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;AACF","sourcesContent":[".selectedHrp {\n  color: black;\n  transform: scale(1.05);\n  margin: 1% 5%;\n  cursor: pointer;\n  font-weight: 500;\n  \n}\n\n.notSelectedHrp {\n  margin: 1% 5%;\n  color: grey;\n  cursor: pointer;\n  \n}\n\n.notSelectedChecklist {\n  height:27%;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 2%;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  font-weight: 500;\n  font-family: \"Merriweather Sans\";\n  border-radius: 20px 20px 20px 20px ;\n  width:95%;\n  background-color: #fff;\n}\n\n.selectedChecklist {\n  height:27%;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 2%;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  font-size: 500;\n  font-family: \"Merriweather Sans\";\n  background-color: #A25035;\n  color:white;\n  transform: scale(1.02);\n  border-radius: 20px 20px 20px 20px ;\n  width:95%;\n}\n\n.notSelectedChecklistUser {\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 3%;\n  color: grey;\n}\n\n.selectedChecklistUser {\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 3%;\n  color: #fff;\n}\n\n.selectedChecklistIcon {\n  float: right;\n  font-size: 20px;\n  margin: 5px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.notSelectedChecklistIcon {\n  float: right;\n  font-size: 20px;\n  margin: 5px;\n  color: black;\n  cursor: pointer;\n}\n\n.notSelectedHrpIcon {\n  float:right;\n  margin:2%;\n  font-size: 20px;\n}\n.selectedHrpIcon {\n  float:right;\n  margin:2%;\n  color:white;\n  font-size: 20px;\n}\n\n.selectedHrpUser{\n  color:white\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
